import React, {Component, createRef} from "react";
import {Box, ButtonBase, Paper, Tab, Tabs} from "@mui/material";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import CloseIcon from "@mui/icons-material/Close";

class TestButton extends Component {
  constructor(props) {
    super(props);
    this.rippleRef = createRef();
  }

  triggerRipple = () => {
    if (this.rippleRef.current) {
      const fakeEvent = {
        clientX: 50, clientY: 50, persist: () => {
        }
      };
      this.rippleRef.current.start(fakeEvent);
      setTimeout(() => this.rippleRef.current.stop(fakeEvent), 300);
    }
  };

  triggerRipple2 = () => {
  };

  render() {
    let tabTitle1 = 'hallo';
    let tabTitle2 = 'hallo';
    return (
      <div>
        <Paper>
          <Tabs>
            <ButtonBase>
              <Box
                selected={this.props.id === this.props.activeTabId}
                sx={{
                  margin: '0px 5px 5px 0px',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  backgroundColor: this.props.id === this.props.activeTabId ? 'var(--color-black-804)' : 'var(--color-primary)',
                  color: this.props.id === this.props.activeTabId ? 'var(--color-white)' : 'var(--color-black)',
                  fontFamily: ['cn-roboto-slab-medium', 'sans-serif'],
                  borderRadius: '0px 8px 0px 0px',
                  '&:hover': {
                    backgroundColor: 'var(--color-secondary)', color: 'var(--color-white)',
                  },
                }}
              >
                <HorizontalLayout className='justify-between'>
                  {tabTitle1}
                  {!this.props.notClosable ? <CloseIcon className="ml-[4px] mr-0"/> : <></>}
                </HorizontalLayout>
              </Box>
              <TouchRipple ref={this.rippleRef} />
            </ButtonBase>
            <ButtonBase>
              <Box
                selected={this.props.id === this.props.activeTabId}
                sx={{
                  margin: '0px 5px 5px 0px',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  backgroundColor: this.props.id === this.props.activeTabId ? 'var(--color-black-804)' : 'var(--color-primary)',
                  color: this.props.id === this.props.activeTabId ? 'var(--color-white)' : 'var(--color-black)',
                  fontFamily: ['cn-roboto-slab-medium', 'sans-serif'],
                  borderRadius: '0px 8px 0px 0px',
                  '&:hover': {
                    backgroundColor: 'var(--color-secondary)', color: 'var(--color-white)',
                  },
                }}
              >
                <HorizontalLayout className='justify-between'>
                  {tabTitle2}
                  {!this.props.notClosable ? <CloseIcon className="ml-[4px] mr-0"/> : <></>}
                </HorizontalLayout>
              </Box>
              <TouchRipple ref={this.rippleRef} />
            </ButtonBase>
            {/*<button onClick={this.triggerRipple}>Ripple Extern Starten</button>*/}
          </Tabs>
        </Paper>

      </div>
    );
  }
}

export default TestButton;
